var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgFacebook = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { fill: "currentColor", d: "M15.004 2.25H2.996a.75.75 0 0 0-.746.746v12.008c0 .412.337.746.746.746h6.465v-5.22H7.706V8.49h1.755V6.986c0-1.743 1.062-2.692 2.629-2.692.525 0 1.046 0 1.568.079V6.19h-1.073c-.851 0-1.013.405-1.013.998v1.297h2.026l-.263 2.04h-1.763v5.228h3.432a.75.75 0 0 0 .746-.746V2.996a.75.75 0 0 0-.746-.746" }) }))); };
export default SvgFacebook;
